import { DemoApiMock } from '../types'
import { getDemoData, matchRestRequest } from '../utils'

export const mockGetLocations: DemoApiMock = {
  shouldMock: (request) =>
    matchRestRequest(
      request,
      '/company/graphql_dispatch/current_company_ae34a1ed',
      'POST'
    ),
  getResponse: async () => {
    const demoData = getDemoData()
    return {
      data: {
        company: {
          locations: demoData.locations,
        },
      },
    }
  },
}
